module.exports = __webpack_public_path__ + "static/media/3.8014bc63.jpg";